import * as React from "react";

import { ReportSignatureKeyResult } from "domain/reportSignatureKeys";

export function useSignatureKeyActionResult(onSucceeded: () => void) {
    const [result, setResult] = React.useState<ReportSignatureKeyResult | undefined>(undefined);
    const succeededRef = React.useRef(false);

    const showResult = (newResult: ReportSignatureKeyResult, succeeded: boolean) => {
        succeededRef.current = succeeded;
        setResult(newResult);
    };

    const hideResult = () => {
        setResult(undefined);
        if (succeededRef.current) {
            onSucceeded();
        }
    };

    return { result, showResult, hideResult };
}
